import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=4fb712c0&scoped=true"
import script from "./BankTransfer.vue?vue&type=script&lang=js"
export * from "./BankTransfer.vue?vue&type=script&lang=js"
import style0 from "./BankTransfer.vue?vue&type=style&index=0&id=4fb712c0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb712c0",
  null
  
)

export default component.exports